import React from 'react';
import IconButton from './IconButton';

export default function CreateButton(props) {
  return <IconButton icon="plus" {...props} />;
}
